import { SourceRunStatus } from '@/lib/sources/source-types';

export type SourceStatusFilter = 'all' | 'ok' | 'warning' | 'error';

export function filterSources(
  sources: SourceRunStatus[],
  search: string,
  statusFilter: SourceStatusFilter
): SourceRunStatus[] {
  return sources.filter((s) => {
    if (statusFilter !== 'all' && s.status !== statusFilter) return false;

    if (search) {
      const q = search.toLowerCase();
      if (
        !s.name.toLowerCase().includes(q) &&
        !s.domain.toLowerCase().includes(q)
      ) {
        return false;
      }
    }

    return true;
  });
}

export function countByStatus(sources: SourceRunStatus[]) {
  let ok = 0;
  let warning = 0;
  let error = 0;
  for (const s of sources) {
    if (s.status === 'ok') ok++;
    else if (s.status === 'warning') warning++;
    else if (s.status === 'error') error++;
  }
  return { total: sources.length, ok, warning, error };
}

export function formatExactDate(isoString: string): string {
  return new Date(isoString).toLocaleString('en-GB', {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}
